import { useSelector } from 'react-redux';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import userRoles from 'constants/userRoles';
import { useUserId } from './useUserId';

export const useIsViewEditBankAccountAllowed = () => {
  const permissions = useSelector(loggedInUserSelectors.permissions);
  const loggedInUserId = useSelector(loggedInUserSelectors.peopleId);
  const user = useSelector(loggedInUserSelectors.employeeDetails);
  const userId = useUserId();

  const isUserAdmin = user?.userRoleId === userRoles.ADMIN;

  let isAllowed = false;

  if (userId === loggedInUserId) {
    isAllowed = true;
  } else {
    isAllowed = permissions?.includes('EMPLOYEE_VIEW_PROFILE');
  }

  return {
    isAllowed,
    isUserAdmin,
  };
};
